import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageManagerService {

  public static surveyStatusKey = 'disableSurvey';

  public static setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public static getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  public static removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
